/*
 * Copyright (c) 2023 SmartWifi - All Rights Reserved.
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 * Proprietary and confidential. No warranty, explicit or implicit provided. In
 * no event will the author be liable for any claim or damages.
 */

import { useContext, useEffect } from "react";
import { ContextUpdater } from "../../Context";
import { useNavigate, useSearchParams } from "react-router-dom";
import { requestLoginTokenVerify } from "../../requests/login/Requests";
import OverlaySpinner from "../../elements/indicators/OverlaySpinner";

const LoginVerify = () => {
  // context
  const contextUpdater = useContext(ContextUpdater);

  // navigation
  const navigate = useNavigate();

  // search params
  const [searchParams] = useSearchParams();
  const pendingToken = searchParams.get("token");

  // handlers
  const handleTokenVerified = () => {
    navigate("/dashboard");
  };

  const handleFailure = () => {
    navigate("/login");
  };

  // verify pending token
  useEffect(() => {
    // no token immediately go back to login page
    if (!pendingToken) {
      handleFailure();
      return;
    }

    // verify token with cloud
    requestLoginTokenVerify({
      context: contextUpdater,
      token: pendingToken,
      showLoading: false,
      onSuccess: handleTokenVerified,
      onFailure: handleFailure
    })

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return <OverlaySpinner />;
};

export default LoginVerify;
